"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteDataDto = void 0;
class SiteDataDto {
    constructor(siteData) {
        this.siteTree = siteData.siteTree;
        this.siteFlatList = siteData.siteFlatList;
    }
}
exports.SiteDataDto = SiteDataDto;
